/**
 * Parses a numeric route param. Returns null for anything that is not a
 * positive integer, so callers can show not-found without hitting the server
 * (`Number("abc")` is NaN, which the API rejects with BAD_REQUEST).
 */
export function parseRouteId(raw) {
  if (!/^\d+$/.test(raw)) return null;
  const id = Number(raw);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}